import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/uploads/:uploadId");

export const Route = createFileRoute("/uploads/$uploadId")({
  head: () => ({
    meta: [
      { title: "Upload detail — LevelLoad" },
      { name: "description", content: "Upload detail — LevelLoad transport planning." },
      { property: "og:title", content: "Upload detail — LevelLoad" },
      { property: "og:description", content: "Upload detail — LevelLoad transport planning." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
